import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { LineGraphComponent } from "./line-graph/line-graph.component";
import { DashboardTableComponent } from "./dashboard-table/dashboard-table.component";
import { DashboardComponent } from "./dashboard-component";
import { LocationGroup } from '../location-group/location-group';
import { HttpClient } from "@angular/common/http";
import { Provinces } from '../provinces/provinces';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'dashboard4',
    template: require('./dashboard4.template.html'),
    styles: [require('./dashboard4.template.css')]
})

export class Dashboard4Component implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild('billsAll') billsAllComponent: LineGraphComponent;
    @ViewChild('billsPerStore') billsPerStoreComponent: LineGraphComponent;
    @ViewChild('uniqueCustomersAll') uniqueCustomersAllComponent: LineGraphComponent;
    @ViewChild('uniqueCustomersPerStore') uniqueCustomersPerStoreComponent: DashboardTableComponent;
    @ViewChild('regularCustomersAll') regularCustomersAllComponent: LineGraphComponent;
    @ViewChild('regularCustomersPerStore') regularCustomersPerStoreComponent: LineGraphComponent;
    @ViewChild('newCustomersAll') newCustomersAllComponent: LineGraphComponent;
    @ViewChild('newCustomersPerStore') newCustomersPerStoreComponent: LineGraphComponent;
    @ViewChild('pointsEarnedAll') pointsEarnedAllComponent: LineGraphComponent;
    @ViewChild('pointsEarnedPerStore') pointsEarnedPerStoreComponent: LineGraphComponent;
    @ViewChild('coffeeCountAll') coffeeCountAllComponent: LineGraphComponent;
    @ViewChild('coffeeCountPerStore') coffeeCountPerStoreComponent: LineGraphComponent;
    @ViewChild('freeCoffeesAll') freeCoffeesAllComponent: LineGraphComponent;
    @ViewChild('freeCoffeesPerStore') freeCoffeesPerStoreComponent: LineGraphComponent;
    @ViewChild('sitesLastTransactionReport') sitesLastTransactionReport: LineGraphComponent;
    @ViewChild('tpsAll') tpsAll: LineGraphComponent;

    public provincesUrl: string = '/api/sites/getProvinces';
    public locationGroupsUrl: string = '/api/sites/getLocationGroups';

    private programShortCode = process.env.program;
    private mdashboardUrl: string = process.env.dashboardUrl;
    private lineGraphs: Array<DashboardComponent>;
    private currentLineGraph: number = 0;
    private showFilter: boolean = false;
    locationGroups: Array<LocationGroup> = [];
    provinces: Array<Provinces> = [];
    metabaseDashboardUrl: any;
    formModel = {
        provinces: [],
        locationGroups: []
    };
    public constructor(

        private http: HttpClient
        , private sanitizer: DomSanitizer
    ) {
    }

    ngOnDestroy(): void {
        this.cancelRefreshLineGraphs();
    }

    ngOnInit(): void {
        this.metabaseDashboardUrl = this.mdashboardUrl;
        console.log('metabaseDashboardUrl: ' + this.metabaseDashboardUrl);
        //setTimeout(self => this.refreshLineGraphs(), 50, self);
    }

    ngAfterViewInit(): void {
        this.registerComponents();
        this.getProvinces();
        this.getLocationGroup();
        this.refreshLineGraphs(this.formModel.provinces, this.formModel.locationGroups);
    }

    getSafeUrl() {
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.metabaseDashboardUrl);     
    }
    private registerComponents(): void {
        this.lineGraphs = [
            /* this.tpsAll,
            this.billsAllComponent,
            this.billsPerStoreComponent,
            this.uniqueCustomersAllComponent,
            this.uniqueCustomersPerStoreComponent,
            this.regularCustomersAllComponent,
            this.regularCustomersPerStoreComponent,
            this.newCustomersAllComponent,
            this.newCustomersPerStoreComponent,
            this.pointsEarnedAllComponent,
            this.pointsEarnedPerStoreComponent,
            this.coffeeCountAllComponent,
            this.coffeeCountPerStoreComponent,
            this.freeCoffeesAllComponent,
            this.freeCoffeesPerStoreComponent,
            this.sitesLastTransactionReport */
        ];
    }

    private cancelRefreshLineGraphs(): void {
        /* let currentSubscription = this.lineGraphs[this.currentLineGraph - 1].subscription;
        if (currentSubscription) {
            currentSubscription.unsubscribe();
            this.currentLineGraph = 0;
        } */
    }

    private refreshLineGraphs(prov, locGroup): void {
        if (this.currentLineGraph == this.lineGraphs.length) {
            this.currentLineGraph = 0;
            return;
        }
        this.currentLineGraph++;
        this.formModel.provinces = prov;
        this.formModel.locationGroups = locGroup
        this.lineGraphs[this.currentLineGraph - 1].updateDashboard(this.formModel.provinces, this.formModel.locationGroups);
    }


    public filterTable() {

        var locGroup: LocationGroup[] = this.formModel.locationGroups;
        var prov: Provinces[] = this.formModel.provinces;
        console.log(prov);
        console.log(locGroup);
        this.refreshLineGraphs(prov, locGroup)

    }

    public getLocationGroup() {
        let self: Dashboard4Component = this;
        return this.http.get<any>(this.locationGroupsUrl)
            .subscribe(result => {
                self.locationGroups = result;
            })
    }

    public getProvinces() {
        let self: Dashboard4Component = this;
        return this.http.get<any>(this.provincesUrl)
            .subscribe(result => {
                self.provinces = result;
            })
    }
    public clearFilterForm(): void {
        this.formModel.provinces = [];
        this.formModel.locationGroups = [];
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/dashboard4.component.ts